import { sourceLevels } from "@/mocks/site";
import { SectionHeading } from "@/components/feature/PageHero";

export default function SourceLevels() {
  return (
    <section className="w-full bg-background-50 px-4 py-12 md:px-6 md:py-16 lg:px-10">
      <SectionHeading
        title="来源分级：从 A 级到 D 级"
        description="每条线索都会先定级，再谈结论。等级决定它能否进入结论区，也决定读它时应该带着几分保留。"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {sourceLevels.map((item, index) => (
          <div
            key={item.level}
            className={`rounded-lg border p-4 md:p-5 ${
              index === 0
                ? "border-accent-300 bg-accent-100"
                : "border-background-200 bg-background-100"
            }`}
          >
            <span
              className={`inline-flex h-9 items-center rounded-md px-3 font-heading text-sm font-bold ${
                index === 0
                  ? "bg-accent-500 text-background-50"
                  : "bg-secondary-100 text-secondary-900"
              }`}
            >
              {item.level}
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
              {item.label}
            </h3>
            <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}